import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';

import SaveIcon from '@material-ui/icons/Save';
import DownLoadIcon from '@material-ui/icons/GetApp';
import PrintIcon from '@material-ui/icons/LocalPrintshop';
import UpLoadIcon from '@material-ui/icons/CloudUpload';
import ForwardIcon from '@material-ui/icons/ArrowForwardIosSharp';
import BackIcon from '@material-ui/icons/ArrowBackIosSharp';
import ClearIcon from '@material-ui/icons/Clear';
import DeleteIcon from '@material-ui/icons/Delete';
import ReloadIcon from '@material-ui/icons/Refresh';
import CalcIcon from '@material-ui/icons/Done';

import indigo from '@material-ui/core/colors/indigo';
import deepOrange from '@material-ui/core/colors/deepOrange';
import pink from '@material-ui/core/colors/pink';
import blueGrey from '@material-ui/core/colors/blueGrey';

const styles = theme => ({
	buttonStyle: {
		width:'80px',
		height:'80px',
		borderRadius:0,
		display: 'block',
		marginBottom:'2px',
		paddingLeft:0,
		paddingRight:0
		
	},
	hasMargin :{
		marginTop:'20px'
	},
	iconStyle:{
		display:'block',
		width:'100%'
	},
	iconSave:{
		backgroundColor:deepOrange[500],
		'&:hover': {
			backgroundColor: deepOrange[800],
		},
		color: theme.palette.getContrastText(deepOrange[500]),
	},
	iconDownLoad:{
		backgroundColor:indigo[500],
		'&:hover': {
			backgroundColor: indigo[800],
		},
		color: theme.palette.getContrastText(indigo[500]),
	},
	iconPrint:{
		backgroundColor:pink[500],
		'&:hover': {
			backgroundColor: pink[800],
		},
		color: theme.palette.getContrastText(pink[500]),
	},
	iconUpload:{
		backgroundColor:blueGrey[800],
		'&:hover': {
			backgroundColor: blueGrey[900],
		},
		color: theme.palette.getContrastText(blueGrey[800]),
	},
	iconReload:{
		backgroundColor:blueGrey[800],
		'&:hover': {
			backgroundColor: blueGrey[900],
		},
		color: theme.palette.getContrastText(blueGrey[800]),
	},
	iconDelete:{
		backgroundColor:blueGrey[900],
		'&:hover': {
			backgroundColor: blueGrey[500],
		},
		color: theme.palette.getContrastText(blueGrey[900]),
	},
	iconCalc:{
		backgroundColor:deepOrange[500],
		'&:hover': {
			backgroundColor: deepOrange[800],
		},
		color: theme.palette.getContrastText(deepOrange[500]),
	},
	iconProcess:{
		backgroundColor:deepOrange[500],
		'&:hover': {
			backgroundColor: deepOrange[800],
		},
		color: theme.palette.getContrastText(deepOrange[500]),
	},
	buttonFont:{
		fontSize:'90%'
	},
	badge:{
		transform:'translate(0, 0)',
		backgroundColor:'#b71c1c'
	}
});

class mainButtons extends Component {
	constructor(props) {
		super(props);
		this.state = {
			IsProcess : false,
			columns: props.columns,
			pageSizes: props.pageSizes,
			rows: props.dataSource,
			currencyColumns: props.currencyColumns,
			currencyFilterOperations: props.currencyFilterOperations
		}
	}

	
	render() {
		const { classes,buttons } = this.props;



		return(
			<div id="main_buttons">
				{buttons.map((button,index)=>{
					const isBadge = (button.isBadge) ? true : false;
					switch(button.type){
						case 'SAVE':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconSave,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<SaveIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "保存" : button.text}</span>
								</Button>
							);
						case 'DL':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconDownLoad,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<DownLoadIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "DL" : button.text}</span>
								</Button>
							);
						case 'PRINT':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconPrint,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<PrintIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "印刷" : button.text}</span>
								</Button>
							);
						case 'UPLOAD':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconUpload,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<UpLoadIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "UPLOAD" : button.text}</span>
								</Button>
							);
						case 'NEXT':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<ForwardIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{button.text}</span>
								</Button>
							);
						case 'BACK':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<BackIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{button.text}</span>
								</Button>
							);
						case 'CLEAR':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<ClearIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "クリア" : button.text}</span>
								</Button>
							);
						case 'DELETE':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconDelete,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<DeleteIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "削除" : button.text}</span>
								</Button>
							);
						case 'RELOAD':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconReload,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<ReloadIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "更新" : button.text}</span>
								</Button>
							);
						case 'CALC':
							return(
								<Button
									disabled={button.disabled}
									key={index}
									variant="contained"
									className={classNames(classes.buttonStyle,classes.iconCalc,(button.hasMargin) ? classes.hasMargin : '')}
									onClick={button.func}
								>
									<CalcIcon className={classes.iconStyle} />
									<span className={classes.buttonFont}>{(!button.text) ? "集計" : button.text}</span>
								</Button>
							);
						default:
							if(isBadge){
								return(
									<Badge
										badgeContent={button.badgeContent}
										color={"primary"}
										classes={{badge: classes.badge, root:classNames((button.hasMargin) ? classes.hasMargin : '')}}
										key={index}
										invisible={isBadge}
									>
										<Button
											disabled={button.disabled}
											variant="contained"
											className={classes.buttonStyle}
											onClick={button.func}
											key={index}
										>
											<span className={classes.buttonFont}>{button.text}</span>
										</Button>
									</Badge>

								);
							}
							else{
								return(
									<Button
										disabled={button.disabled}
										variant="contained"
										className={classNames(classes.buttonStyle, (button.hasMargin) ? classes.hasMargin : '')}
										onClick={button.func}
										key={index}
									>
										<span className={classes.buttonFont}>{button.text}</span>
									</Button>
								);
							}

					}
				})}
			</div>
		);
	}
}
mainButtons.propTypes = {
	buttons:PropTypes.array
	
};
mainButtons.defaultProps = {
	buttons:[]
};
export default withStyles(styles)(mainButtons);


// WEBPACK FOOTER //
// ./src/common/components/main-buttons.js